import React from "react";
import { Link } from "react-router-dom";

/**
 * Visible breadcrumb trail. Mirrors the JSON-LD Breadcrumb schema injected
 * on the same pages so Google can render rich breadcrumbs in search results.
 *
 * items: [{ label, to }] — last item is current page (rendered as text).
 */
export default function Breadcrumbs({ items = [] }) {
    if (!items.length) return null;
    return (
        <nav
            data-testid="breadcrumbs"
            aria-label="Breadcrumb"
            className="relative z-10 bg-black/40 backdrop-blur border-b border-white/5"
        >
            <ol className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-3 flex items-center gap-2 text-xs text-white/50 overflow-x-auto whitespace-nowrap">
                {items.map((it, i) => {
                    const isLast = i === items.length - 1;
                    return (
                        <li key={i} className="flex items-center gap-2">
                            {i > 0 && <span className="text-white/25">/</span>}
                            {isLast || !it.to ? (
                                <span className="text-gold font-medium" aria-current={isLast ? "page" : undefined}>{it.label}</span>
                            ) : (
                                <Link to={it.to} className="hover:text-white transition-colors">{it.label}</Link>
                            )}
                        </li>
                    );
                })}
            </ol>
        </nav>
    );
}
